import { ThemeContext } from '@coorum-research/core/src/components/ThemeContext'
import { coorumColors } from '@coorum-research/core/src/survey/coorumTheme'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import React from 'react'
import { ResearchClientOpenFeatureProvider } from './feature-flag/research-provider/ResearchClientOpenFeatureProvider'
import { PageStoreProvider } from './PageStoreProvider'
import { SessionProvider } from './SessionProvider'

const queryClient = new QueryClient()

export function CoorumResearchApp() {
  return (
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <ResearchClientOpenFeatureProvider>
          <SessionProvider>
            <ThemeContext.Provider value={coorumColors}>
              <PageStoreProvider />
            </ThemeContext.Provider>
          </SessionProvider>
        </ResearchClientOpenFeatureProvider>
      </QueryClientProvider>
    </React.StrictMode>
  )
}
